import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export function CommentsBox({ comments = [], onAdd, allowInternal, testid = "comments", placeholder = "Escriba un comentario…" }) {
  const [text, setText] = useState("");
  const [internal, setInternal] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try {
      await onAdd(text.trim(), internal);
      setText("");
      toast.success("Comentario agregado");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid={testid}>
      <ul className="mb-4 space-y-3">
        {comments.length === 0 && <li className="text-sm text-slate-400">Sin comentarios.</li>}
        {comments.map((c) => (
          <li key={c.id} className={`rounded-md border p-3 text-sm ${c.internal ? "border-amber-200 bg-amber-50/60" : "border-slate-200 bg-white"}`}>
            <div className="mb-1 flex flex-wrap items-center gap-2 text-xs text-slate-500">
              <span className="font-semibold text-slate-700">{c.by_name}</span>
              <span>{fmtDateTime(c.at)}</span>
              {c.internal && <span className="inline-flex items-center gap-1 text-amber-700"><Lock className="h-3 w-3" /> Interno</span>}
            </div>
            <p className="whitespace-pre-wrap text-slate-700">{c.text}</p>
          </li>
        ))}
      </ul>
      <form onSubmit={submit} className="space-y-2">
        <textarea className="field-input" rows={2} value={text} onChange={(e) => setText(e.target.value)} placeholder={placeholder} data-testid={`${testid}-input`} />
        <div className="flex flex-wrap items-center justify-between gap-2">
          {allowInternal ? (
            <label className="flex items-center gap-2 text-xs text-slate-600">
              <input type="checkbox" checked={internal} onChange={(e) => setInternal(e.target.checked)} className="accent-amber-600" data-testid={`${testid}-internal`} /> Solo interno (el cliente no lo verá)
            </label>
          ) : <span />}
          <Button size="sm" type="submit" disabled={busy || !text.trim()} data-testid={`${testid}-submit`}>
            {busy && <Loader2 className="mr-2 h-3.5 w-3.5 animate-spin" />}Agregar comentario
          </Button>
        </div>
      </form>
    </div>
  );
}
